import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../common/common.service";
import { MainServiceService } from "../main-service.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  constructor(private commonService: CommonService,private mainService:MainServiceService) { }
  userData:any;
  endDate:any
  ngOnInit() {
    
    this.userData = this.commonService.getUser();
    if (this.userData.profile_pic == null || this.userData.profile_pic == "") {
      this.userData.profile_pic = "./assets/images/logoIcon@3x.png";
    }
  }

  onLogout() {
  this.updateTime();
  }
  updateTime(){
    let startDate = localStorage.getItem('startTime')
    let startEpocTemp = new Date(startDate);
    let startEpoc=Math.floor(startEpocTemp.getTime() / 1000);
    this.endDate = new Date();
    let endEpocTemp = new Date(this.endDate);
    let endEpoc=Math.floor(endEpocTemp.getTime() / 1000);
    let diff =  endEpoc-startEpoc;

    let request = {
    "userId":this.userData['userId'],
    "startTime":startEpoc,
    "endTime":endEpoc,
    "type":"appTime",
    "useTime":diff
    }
    this.mainService.saveTime(request).subscribe(res => {
      if (res["message"] == "Success") {
        this.commonService.logOut();
      } else {

      }
    });
  }
}
